import React, { useState, useEffect, useCallback } from "react";
import { Container, Navbar, Nav, Button, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Image from "react-bootstrap/Image";
import { IMAGES } from "../assets/images/images";
import { Icon } from "@iconify/react";
import { is_influencer, isAuthenticated, isHost } from "../utility/auth";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Header = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.dir = lng === "he" ? "rtl" : "ltr";
    localStorage.setItem("language", lng);
  };
  const currentLanguage = i18n.language;
  const profileImg = localStorage.getItem("profile_pic") || null;
  const navigate = useNavigate();
  const [showNav, setShowNav] = useState(false);
  const location = useLocation();

  const toggleNav = useCallback(() => {
    setShowNav((prevShowNav) => !prevShowNav);
  }, []);

  // Close the nav when the URL changes
  useEffect(() => {
    setShowNav(false);
  }, [location]);

  // Sticky Menu Area
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".navbar");
      const scrollTop = window.scrollY;
      scrollTop >= 250
        ? header.classList.add("is-sticky")
        : header.classList.remove("is-sticky");
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogout = () => {
    // setTimeout(() => {}, 1000);
    localStorage.clear();
    navigate("/login");
  };

  return (
    <Navbar collapseOnSelect expand="md" className="fixed-top">
      <Container className={currentLanguage === "he" ? 'rtlConFu' : 'ltrConFu'} fluid>
        <Navbar.Brand className="navBarRtlStyle" as={Link} to="/">
          <Image src={IMAGES.Logo} width="160" alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={toggleNav}
        >
          <Icon icon="ri:menu-2-fill" fontSize={25} color={"#000000"} />
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav" in={showNav}>
          <Nav className="mobileNav">
            <div className="linkNav" >
              {/* <Image
           
                className="navbaruserImg"
                alt="User"
              /> */}

              <img
                className="navbaruserImg"
                src={profileImg == undefined
                  ? IMAGES.UserDisImage
                  : profileImg || IMAGES.UserDisImage}
                onError={(e) => e.target.src = IMAGES.UserDisImage}
                style={{ width: '60px', height: '60px' }}
              />



              <NavDropdown
                title={<Icon icon="iconoir:language" fontSize={35} />}
                className="dropMenu dropMenuMobile"
              >
                <NavDropdown.Item onClick={() => changeLanguage("en")}>
                  {t("header.language.english")}
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => changeLanguage("he")}>
                  {t("header.language.hebrew")}
                </NavDropdown.Item>
              </NavDropdown>
              <div className={currentLanguage === 'he' ? "closeNav rtlCloseNav" : "closeNav"} >
                <Icon
                  icon="bitcoin-icons:cross-filled"
                  fontSize={28}
                  color={"#000000"}
                  onClick={toggleNav}
                />
              </div>
            </div>
            {!isAuthenticated() ? (
              <Nav.Link className={currentLanguage === "he" ? 'rtlLoginBtn' : 'ltrLoginBtn'} as={Link} to="/login">
                {t("header.login")}
              </Nav.Link>
            ) : isHost() ? (
              <>
                <Nav.Link as={Link} to="/property-dashboard">
                  {t("header.dashboard")}
                </Nav.Link>
                <Nav.Link as={Link} to="/my-properties">
                  {t("header.my_properties")}
                </Nav.Link>
                <Nav.Link as={Link} to="/property-bookings">
                  {t("header.my_bookings")}
                </Nav.Link>
                <Nav.Link as={Link} to="/user-profilesetting">
                  {t("header.profile_settings")}
                </Nav.Link>
                <Nav.Item onClick={() => handleLogout()}>{t("header.logout")}</Nav.Item>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/wishlist">
                  {t("header.wishlist")}
                </Nav.Link>
                <Nav.Link as={Link} to="/mybooking">
                  {t("header.my_booking")}
                </Nav.Link>
                {is_influencer() && (
                  <Nav.Link as={Link} to="/my-referral">
                    {t("header.refer")}
                  </Nav.Link>
                )}
                <Nav.Link as={Link} to="/user-profilesetting">
                  {t("header.profile_settings")}
                </Nav.Link>
                <Nav.Item onClick={() => handleLogout()}>{t("header.logout")}</Nav.Item>
              </>
            )}
            {!isAuthenticated() && (
              <Button
                as={Link}
                className={currentLanguage === "he" ? "rtlBtn" : "ltrBnt"}
                to={
                  location.pathname === "/propertyowner-signup"
                    ? "/user-signup"
                    : "/propertyowner-signup"
                }
                variant="primary"
              >
                {location.pathname === "/propertyowner-signup"
                  ? t("header.become_a_user")
                  : t("header.become_a_host")}
              </Button>
            )}

          </Nav>

          <Nav className="ms-auto desktop">
            {!isAuthenticated() && (
              <Button
                as={Link}
                className={currentLanguage === "he" ? "rtlBtn" : "ltrBnt"}
                to={
                  location.pathname === "/propertyowner-signup"
                    ? "/user-signup"
                    : "/propertyowner-signup"
                }
                variant="outline-primary"
              >
                {location.pathname === "/propertyowner-signup"
                  ? t("header.become_a_user")
                  : t("header.become_a_host")}
              </Button>
            )}

            <NavDropdown
              title={<Icon icon="iconoir:language" fontSize={35} />}
              className={currentLanguage === "he" ? "dropMenu orderClass" : "dropMenu"}
            >
              <NavDropdown.Item onClick={() => changeLanguage("en")}>
                {t("header.language.english")}
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => changeLanguage("he")}>
                {t("header.language.hebrew")}
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              className={currentLanguage == "he" ? "rtlNavDropDown" : "ltrNavDropDown"}
              title={
                <div className="proBox"  >
                  <Icon icon="ri:menu-2-fill" fontSize={25} color={"#000000"} />
                  <Image
                    src={
                      profileImg == null ||
                        profileImg == "null" ||
                        profileImg == "undefined" ||
                        profileImg == undefined
                        ? IMAGES.UserDisImage
                        : profileImg
                    }
                    className="navbaruserImg"
                    alt="User"
                  />
                </div>
              }
              id="basic-nav-dropdown"
            >
              {!isAuthenticated() ? (
                <NavDropdown.Item className={currentLanguage === "he" ? 'rtlLoginBtn' : 'ltrLoginBtn'} as={Link} to="/login">
                  {t("header.login")}
                </NavDropdown.Item>
              ) : isHost() ? (
                <>
                  <NavDropdown.Item as={Link} to="/property-dashboard">
                    {t("header.dashboard")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/my-properties">
                    {t("header.my_properties")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/property-bookings">
                    {t("header.my_bookings")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/user-profilesetting">
                    {t("header.profile_settings")}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={handleLogout}>
                    {t("header.logout")}
                  </NavDropdown.Item>
                </>
              ) : (
                <>
                  <NavDropdown.Item as={Link} to="/wishlist">
                    {t("header.wishlist")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/mybooking">
                    {t("header.my_booking")}
                  </NavDropdown.Item>
                  {is_influencer() && (
                    <NavDropdown.Item as={Link} to="/my-referral">
                      {t("header.refer")}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Item as={Link} to="/user-profilesetting">
                    {t("header.profile_settings")}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={handleLogout}>
                    {t("header.logout")}
                  </NavDropdown.Item>
                </>
              )}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
